import {enumsService} from 'services';

const yandexMKBTypes = new Set(['YANDEX_MCBANNER_CAMPAIGN', 'YANDEX_SMART_BANNER_CAMPAIGN', 'YANDEX_UNDEFINED_CAMPAIGN']);
const ozonBMTypes = new Set(['OZON_PAY_PER_CLICK', 'OZON_BRAND_SHELF']);

export const FETCH_ENUMS = 'FETCH_ENUMS';

function getterFindById (stateVar) {
  return function (idToFind) {
    return stateVar.find(i => i.id === idToFind);
  };
}

const enumsStore = {
  namespaced: true,
  state: {
    placementTypes: [],
    placementStrategyTypes: [],
    adFormats: [],
    currencies: [],
    timezones: [],

    balancingPeriods: [],

    dashboardAccessTypes: [],
    profileGoalType: [],

    customMetricTypes: [],

    projectStatuses: [],
    accountStatuses: [],
    accountTypes: [],

    orderFormats: [],
    orderPayTypes: [],
    orderGenders: [],

    regions: []
  },
  mutations: {
    SET_ENUM (state, [enumName, val]) {
      let _val = val;
      if (!Array.isArray(_val)) {
        _val = val.items;
      }
      state[enumName] = _val;
    }
  },
  getters: {
    placementTypes: (state) => state.placementTypes,
    getPlacementTypeById: state => getterFindById(state.placementTypes),
    getPlacementStrategyTypeById: state => getterFindById(state.placementStrategyTypes),
    adFormats: (state) => state.adFormats,
    getAdFormatById: state => getterFindById(state.adFormats),
    yandexMKBPlacementTypes: (state) => state.placementTypes.filter(i => yandexMKBTypes.has(i.id)),
    ozonBMPlacementTypes: (state) => state.placementTypes.filter(i => ozonBMTypes.has(i.id)),
    getUnsupportedBidmanagerPlacementsList: (state, getters) => getters.yandexMKBPlacementTypes.map(
      (item) => item.name.toLowerCase()
    ),
    getSupportedBidmanagerPlacementsList: (state, getters) => getters.ozonBMPlacementTypes.map(
      (item) => item.name.toLowerCase()
    ),
    fetchedPlacementTypes: (state, getters) => getters.yandexMKBPlacementTypes,
    currencies: (state) => state.currencies,
    getCurrencyById: (state) => (id) => state.currencies.find(i => i.id === id),
    timezones: state => state.timezones,

    balancingPeriods: state => state.balancingPeriods,

    profileGoalType: state => state.profileGoalType,
    getGoalTypeById: state => getterFindById(state.profileGoalType),

    getDashboardAccessTypesById: state => getterFindById(state.dashboardAccessTypes),

    customMetricTypes: state => state.customMetricTypes,
    getCustomMetricTypeById: state => getterFindById(state.customMetricTypes),

    projectStatuses: state => state.projectStatuses,
    getProjectStatusById: state => getterFindById(state.projectStatuses),
    accountStatuses: state => state.accountStatuses,
    getAccountStatusById: state => getterFindById(state.accountStatuses),
    accountTypes: state => state.accountTypes,
    getAccountTypeById: state => getterFindById(state.accountTypes),

    orderFormats: state => state.orderFormats,
    getOrderFormatById: state => getterFindById(state.orderFormats),
    orderPayTypes: state => state.orderPayTypes,
    getOrderPayTypeById: state => getterFindById(state.orderPayTypes),
    orderGenders: state => state.orderGenders,
    getOrderGenderById: state => getterFindById(state.orderGenders),

    regions: state => state.regions,
    getRegionById: state => getterFindById(state.regions)
  },
  actions: {
    async [FETCH_ENUMS] (context, enumNames = []) {
      const callFetchAndMutate = async (enumName) => {
        if (!enumsService[enumName]) {
          console.warn(`undefinedEnum [${enumName}]`);
          return;
        }
        const data = await enumsService[enumName](context.rootGetters['user/userLocale']);
        context.commit('SET_ENUM', [enumName, data]);
      };

      const promises = enumNames.map(i => callFetchAndMutate(i));

      return await Promise.all(promises);
    }
  }
};

export default enumsStore;
